export const Types = {
  postLogin: 'login/postLogin',
  mtkLogin: 'login/mtkLogin',
  getStoresByCPF: 'login/getStoresByCPF',
  updateLoginData: 'login/updateLoginData',
  updateLogoff: 'login/updateLogoff',
  reset: 'login/reset'
}

export function postLogin ({ code, codeVerifier, login, password, type = '' } = {}) {
  return {
    type: Types.postLogin,
    payload: { code, codeVerifier, login, password, type }
  }
}

export function mtkLogin ({ token, storeCodes = [], campaignId } = {}) {
  return {
    type: Types.mtkLogin,
    payload: { token, storeCodes, campaignId }
  }
}

export function getStoresByCPF ({ cpf } = {}) {
  return {
    type: Types.getStoresByCPF,
    payload: { cpf }
  }
}

export function updateLoginData ({ loginData = {}, error } = {}) {
  return {
    type: Types.updateLoginData,
    payload: { loginData, error }
  }
}

export function updateLogoff () {
  return {
    type: Types.updateLogoff
  }
}

export function reset () {
  return {
    type: Types.reset
  }
}
